/**
 * Composition method for EPIC HR App content
 * 
 * Author: Andrea López
 */
 import { computed, ref, watch } from 'vue';
 import { useStore } from 'vuex';

// Frames
import EpicStudyOverviewFrame from '../components/frames/epic-study-overview-frame.vue';
import EpicStudyDesignFrame from '../components/frames/epic-study-design-frame.vue';
import EpicStudyEndpointsFrame from '../components/frames/epic-study-endpoints-frame.vue';
import EpicSelectedInclusionFrame from '../components/frames/epic-selected-inclusion-criteria-frame.vue';
import EpicSelectedExclusionFrame from '../components/frames/epic-selected-exclusion-criteria-frame.vue';
import EpicStatisticalMethodsFrame from '../components/frames/epic-statistical-methods-frame.vue';
import EpicPrimaryEndpointFrame from '../components/frames/epic-primary-endpoint-frame.vue';
import EpicPrimaryEndpointOverTimeFrame from '../components/frames/epic-primary-endpoint-over-time-frame.vue';
import EpicSecondaryEndpointFrame from '../components/frames/epic-secondary-endpoint-frame.vue';
import EpicSustainedSymptomAlleviation from '../components/frames/epic-sustained-symptom-alleviation.vue';
import EpicSustainedSymptomAlleviationTwo from '../components/frames/epic-sustained-symptom-alleviation-two.vue';
import EpicCovid19RelatedHospitalisation from '../components/frames/epic-covid-19−related-hospitalization.vue';
import EpicCovid19RelatedMedicalVisits from '../components/frames/epic-covid-19–related-medical-visits.vue';
import EpicPaxlovid from '../components/frames/epic-paxlovid.vue';
import EpicSafetyOutcomesFrame from '../components/frames/epic-safety-outcomes-frame.vue';
import EpicCommonAesFrame from '../components/frames/epic-common-aes-frame.vue';

export function epicNavigationComposition (datum) {
    const store = useStore();
    
    const componentMap = {
        'epic-study-overview': EpicStudyOverviewFrame,
        'epic-study-design': EpicStudyDesignFrame,
        'epic-study-endpoints': EpicStudyEndpointsFrame,
        'epic-selected-inclusion-criteria': EpicSelectedInclusionFrame,
        'epic-selected-inclusion-criteria-extra': EpicSelectedInclusionFrame,
        'epic-selected-exclusion-criteria': EpicSelectedExclusionFrame,
        'epic-statistical-methods': EpicStatisticalMethodsFrame,
        'epic-primary-endpoint': EpicPrimaryEndpointFrame,
        'epic-primary-endpoint-over-time': EpicPrimaryEndpointOverTimeFrame,
        'epic-sustained-symptom-alleviation': EpicSustainedSymptomAlleviation,
        'epic-sustained-symptom-alleviation-two': EpicSustainedSymptomAlleviationTwo,
        'epic-covid-19−related-hospitalization': EpicCovid19RelatedHospitalisation,
        'epic-covid-19–related-medical-visits': EpicCovid19RelatedMedicalVisits,
        'epic-paxlovid': EpicPaxlovid,
        'epic-secondary-endpoint': EpicSecondaryEndpointFrame,
        'epic-safety-outcomes': EpicSafetyOutcomesFrame,
        'epic-common-aes': EpicCommonAesFrame
    };
    
    // Computed active section
    const activeSection = computed((): string => store.getters.get_ehrActiveSection);
    const activeFrame = computed((): string => store.getters.get_ehrActiveFrame);
    const activeComponent = computed((): any => (componentMap[activeFrame.value] || null));
    const screen = computed((): string => store.getters.get_ehrScreen);
    
    // Navigation events
    const activeFrameIndex = ref(0);

    const updatedFrameIndex = (index: number) => {
        activeFrameIndex.value += index;
    }

    // Screen navigation
    function switchScreen(screenTo: string) {
        store.dispatch('axn_updateEhrScreen', screenTo);
    }

    const getScreenNav = (direction) => {
        if (screen.value === 'timeline' && direction === -1) {
            if (activeFrameIndex.value === -1) {
                activeFrameIndex.value = 0;
                switchScreen('splash');
            }
        }
    }

    const onclickNav = (direction: number) => {
        if (direction === -1) {
            if (activeFrameIndex.value >= 0) {
                updatedFrameIndex(-1);
                getScreenNav(-1);
            }
        }
        
        if (direction === 1) {
            if (activeFrameIndex.value < datum.value.length - 1) {
                updatedFrameIndex(1);
            }
        }
    }

    function switchFrame(frameTo: string) {
        store.dispatch('axn_updateEhrActiveFrame', frameTo);
    }

    watch(activeFrameIndex, () => {
        if (activeFrameIndex.value !== -1) {
            switchFrame(datum.value[activeFrameIndex.value].endpointId);
        }
    })
    
    watch(activeFrame, () => {
        activeFrameIndex.value = datum.value.map((_: any) => _.endpointId).indexOf(activeFrame.value);
    })

    return {
        activeComponent, activeSection, activeFrame,
        activeFrameIndex, screen, onclickNav
    }
}